module.exports = __webpack_public_path__ + "static/media/19.6207b40f.jpeg";